import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { UrlReferenceService } from './url-reference.service';

@Injectable({
  providedIn: 'root',
})
export class HealthDeclarationService {
  private getApiUrl(
    employeeId: string,
    memberType: string
  ): string {
    return `${this.urlRef.getHealthDeclarationUrl()}/${employeeId}/type/${memberType}`;
  }

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private urlRef: UrlReferenceService
  ) {}

  getHealthDeclaration(
    employeeId: string,
    memberType: string
  ): Observable<any> {
    this.loaderService.show();
    return this.http
      .get<any>(this.getApiUrl(employeeId, memberType))
      .pipe(
        catchError(this.handleError),
        finalize(() => this.loaderService.hide())
      );
  }

  patchHealthDeclaration(
    memberId: string,
    memberType: string,
    data: any
  ): Observable<any> {
    this.loaderService.show();
    return this.http
      .patch<any>(
        `${this.urlRef.getHealthDeclarationUrl()}/${memberId}/type/${memberType.toLowerCase()}`,
        data
      )
      .pipe(finalize(() => this.loaderService.hide()));
  }

  postHealthDeclaration(
    memberId: string,
    memberType: string,
    data: any
  ): Observable<any> {
    this.loaderService.show();
    return this.http
      .post<any>(
        `${this.urlRef.getHealthDeclarationUrl()}/${memberId}/type/${memberType.toLowerCase()}`,
        data
      )
      .pipe(finalize(() => this.loaderService.hide()));
  }

  createHealthDeclaration(
    
    employeeId: string,
    memberType: string,
    data: any
  ): Observable<any> {
    this.loaderService.show();

    return this.http
      .post<any>(this.getApiUrl( employeeId, memberType), data)
      .pipe(finalize(() => this.loaderService.hide()));
  }

  updateHealthDeclaration(
    companyId: number | undefined,
    employeeId: string,
    memberType: string,
    data: any
  ): Observable<any> {
    this.loaderService.show();

    return this.http
      .patch<any>(this.getApiUrl( employeeId, memberType), data)
      .pipe(finalize(() => this.loaderService.hide()));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 404) {
      return throwError(() => ({
        status: 404,
        message: 'Health declaration not found',
      }));
    }
    return throwError(
      () => new Error('An unexpected error occurred. Please try again later.')
    );
  }
}
